<div *ngIf="showUsers; else showSpinner">
  <div class="container-fluid marginLeft4rem">
    <!-- *ngIf="isAdmin; else noAdmin" -->
    <div *ngIf="enableUserDetail" class="row volver">
      <app-svg
        (click)="goBackUserTable()"
        class="icon-arrow-left pointer margen"
        name="arrow-left"
      ></app-svg>
      <div class="margen styleGoOnBack">{{ "USER.BACK" | translate }}</div>
    </div>
    <div *ngIf="!enableUserDetail && !enableUserForm" class="row">
      <div class="col-6 budgetStyle">
        <app-alarm-budget
          (budgetCollectionEmitter)="filterByState($event)"
          [budgetCollection]="budgetCollection"
        >
        </app-alarm-budget>
      </div>
      <div class="col-6 buttonPosition">
        <button
          mat-mini-fab
          matTooltip="{{ 'USER.ADD_USER' | translate }}"
          matTooltipPosition="above"
          matTooltipClass="addUser"
          class="float-right addUser1 margin"
          (click)="showUserForm()"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="container-fluid tableStyle">
        <app-alarm-table
          *ngIf="!enableUserDetail && !enableUserForm"
          [tableUser]="true"
          [elementData]="elementData"
          [activatedStyle]="activatedStyle"
          (selectionStateEmitter)="controlStateButtonStyle($event)"
          (selectionUserRowEmitter)="selectUser($event)"
          (changeUserStateEmitter)="confirmChangeUserState($event)"
          (deleteUserEmitter)="confirmDeleteUser($event)"
          (editUserEmitter)="editUser($event)"
        >
        </app-alarm-table>
        <div class="alarmForm">
          <app-user-form
            *ngIf="enableUserForm"
            [formMode]="formMode"
            (cancelEmitter)="cancelForm()"
            (submitEmitter)="addUser($event)"
            [userToEdit]="userSelected"
            (editEmitter)="editUserAtBack($event)"
            (factoriesRemoveEmitter)="removeFactoriesOfUser($event)"
            (factoriesAddEmitter)="addFactoriesToUser($event)"
          ></app-user-form>
        </div>
        <app-user-detail
          *ngIf="enableUserDetail"
          [user]="userSelected"
        ></app-user-detail>
      </div>
    </div>
  </div>
</div>

<ng-template #showSpinner>
  <app-loading [loadingText]="loadingText"></app-loading>
</ng-template>

<ng-template #noAdmin>
  <div class="container mtop5">
    <div class="text-center">
      <div class="">
        <i class="material-icons biggerIcon">not_interested</i>
      </div>
    </div>
    <div class="text-center">
      <div>
        <h3>{{ "USER.WARNING_MESSAGES.NO_ADMIN" | translate }}</h3>
        {{ "USER.WARNING_MESSAGES.NO_ADMIN_2" | translate }}
      </div>
    </div>
  </div>
</ng-template>
